<template>
    <div class="profile_box">
        <div class="nav_header">
            <h2>邮寄地址</h2>
        </div>

        <el-row type="flex" justify="space-between" align="middle">
            <el-col style="width:auto">
                 <el-button icon="el-icon-plus" @click="addressVisible=true">新增邮寄地址</el-button>
            </el-col>
        </el-row>    

        <white-space />   

        <el-card class="box-card" :body-style="{padding:0}" v-if="data.length">
            <el-table :data="data" style="width: 100%">
                <el-table-column prop="is_default" label="" width="120">
                    <template slot-scope="scope">
                        <el-button v-if="!scope.row.is_default" size="small" @click="onIsDefault(scope.row.id)">设为默认</el-button>
                        <el-button type="primary" plain size="small" v-else>默认地址</el-button>
                    </template>
                </el-table-column>

                <el-table-column prop="name" label="收件人姓名" width="150">
                </el-table-column>
                <el-table-column prop="mobile" label="收件人手机号码" width="150">
                </el-table-column>
                <el-table-column prop="address" label="详细地址">
                </el-table-column>

                 <el-table-column width="80">
                      <template slot-scope="scope">
                        <el-button v-if="!scope.row.is_default" size="small" type="danger" @click="onDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </el-card>    

        <Empty v-if="!data.length" />
       
        <AddressCreate :visible="addressVisible" @addressHidden="()=>{addressVisible = false}" @loadAddress="this.load"/>

    </div>
</template>
<script>
    import AddressCreate from './AddressCreate';

    const requestUrl = "/personal/address";
    export default {
        data() {
            return {
                disabled: false,
                data: [],
                addressVisible:false,
            };
        },
        created() {
            this.load();
            this.$store.commit("changeOwnActive", "personal-profile");
        },
        components:{AddressCreate},
        methods: {
            load() {
                //url参数
                this.$http.get(requestUrl).then(response => {
                    if (response.success) {
                        this.data = response.data;
                    }
                });
            },
            onDelete(id){
                this.$confirm("是否删除当前地址，删除后将无法恢复", "提醒", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = "删除中...";

                            this.$http;
                            this.$http
                                .delete(requestUrl+'/' + id)
                                .then(response => {
                                    if (!response.success) {
                                        instance.message = response.message
                                        instance.title = '删除失败'
                                        instance.type = 'error'
                                        instance.showConfirmButton = false
                                    } else {
                                        this.load();
                                        done();
                                    }
                                })
                                .catch()
                                .then(() => {
                                    instance.confirmButtonLoading = false;
                                });
                        } else {
                            done();
                        }
                    }
                });
            },
            onIsDefault(id){
                this.$confirm("是否设置当前地址为默认邮寄地址？", "提醒", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = "提交中...";

                            this.$http;
                            this.$http
                                .put(requestUrl+'/' + id,{is_default:1})
                                .then(response => {
                                    if (!response.success) {
                                        instance.message = response.message
                                        instance.title = '提交失败'
                                        instance.type = 'error'
                                        instance.showConfirmButton = false
                                    } else {
                                        this.load();
                                        done();
                                    }
                                })
                                .catch()
                                .then((response) => {
                                    instance.confirmButtonLoading = false;
                                });
                        } else {
                            done();
                        }
                    }
                })
            }
        }
    };

</script>

<style scoped lang="css">
    /* input[type="text"]{
  outline: #f08c19;
} */
</style>
